export default __webpack_public_path__ + "static/media/Pytm.c3535276.png";